import React from 'react'

import withContainer from './container'
import Component from './component'

export default React.memo(withContainer(Component))

